import type { EventSettings, VoiceSource } from '@bingo/shared';

/**
 * Quem fala o quê.
 *
 * Mora aqui, e não dentro de cada tela, pelo mesmo motivo de `evaluateClaim`
 * estar no @bingo/shared: a regra é fácil de errar de um jeito caro. Com os
 * dois aparelhos falando, o salão ouve eco; com nenhum, a narração some sem
 * erro nenhum. Uma definição só, importada pelo telão e pelo /controle.
 */

export interface SpeakingDevice {
  /** Qual fonte ESTE aparelho representa. */
  kind: Extract<VoiceSource, 'SYNTHESIS' | 'PHONE'>;
  /** O gesto do usuário já liberou o áudio aqui? */
  unlocked: boolean;
}

export type NarrationSettings = Pick<EventSettings, 'narration' | 'voiceSource'>;

/** Pode falar? Depende só da fonte configurada e do desbloqueio. */
export function canSpeak(device: SpeakingDevice, source: VoiceSource): boolean {
  return device.kind === source && device.unlocked;
}

/**
 * Deve falar esta mensagem?
 *
 * `force` é o "Repetir": pedido EXPLÍCITO do operador, que fala mesmo com a
 * narração automática desligada — há quem use locutor ao vivo e ainda assim
 * queira a repetição falada quando pede.
 */
export function shouldSpeak(
  device: SpeakingDevice,
  settings: NarrationSettings,
  options: { force?: boolean } = {},
): boolean {
  if (!canSpeak(device, settings.voiceSource)) return false;
  return options.force === true || settings.narration;
}
